module.exports = __webpack_public_path__ + "img/step4-no.bfcd1678.png";